import { useMemo } from 'react'

import { getCurrentAppId } from '../utils'
import { AppTheme, getThemeByAppId } from '../config/themes'

export const useAppTheme = (): AppTheme => {
  const appId = getCurrentAppId()

  return useMemo(() => {
    return getThemeByAppId(appId)
  }, [appId])
}

export const useAppThemeColors = () => {
  const theme = useAppTheme()
  return theme.colors
}

export const useAppThemeBranding = () => {
  const theme = useAppTheme()
  return theme.branding
}

export const useAppThemeMeta = () => {
  const theme = useAppTheme()
  return theme.meta
}
